
export const remittanceStatusConfig = {
    n: { canChangeStatus: (rem, user) => false },
    s: { canChangeStatus: (rem, user) => !rem.shouldRecalculate },
    v: { canChangeStatus: (rem, user) => user.isSuperAdmin || rem.isOpen() },
}
